module.exports = __webpack_public_path__ + "static/media/feature_01.08ce395.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/feature_01.mp4
// module id = I5zc
// module chunks = 1